import { Tip } from '@dweber019/backstage-plugin-tips';
import { isEntityOfKind } from '@dweber019/backstage-plugin-tips';
import React from 'react';

/** @public */
export const customTips: Tip[] = [
    {
        title: 'Keep Your catalog-info.yaml Files Up-to-Date',
        content: (
            <>
                <p>
                    Keep your <strong>catalog-info.yaml</strong> files updated to ensure services are easy to find, linked, and useful.
                </p>
                <ul style={{ margin: '10px 0 0 20px', paddingBottom: '20px' }}>
                    <li>
                        Set the <strong>owner</strong> field to identify the responsible team or person.
                    </li>
                    <li>
                        Use the <strong>description</strong> field for a quick service summary.
                    </li>
                    <li>
                        Remove outdated annotations or broken links regularly.
                    </li>
                </ul>
            </>
        )
        ,
        activate: async ({ entity, identity }) =>
            !!entity && !!identity &&
            isEntityOfKind(entity, ['component'])
    },
    {
        title: 'Use Tags to Organize Your Services',
        content: (
            <>
                <p>
                    <strong>Why?</strong>
                    <p>Tags help categorize and group services, making it easier to find related components in the catalog.</p>
                </p>
                <p>
                    <strong>How to Add Tags:</strong>
                </p>
                <ul style={{ margin: '10px 0 0 20px', paddingBottom: '20px' }}>
                    <li>Open your <strong>catalog-info.yaml</strong> file.</li>
                    <li>Add a <strong>tags</strong> field under the <strong>metadata</strong> section.</li>
                    <li>List relevant keywords that describe your service.</li>
                </ul>
            </>
        ),
        activate: async ({ entity, identity }) =>
            !!entity && !!identity &&
            isEntityOfKind(entity, ['component'])
    },
];